// extracted by mini-css-extract-plugin
export default {"header":"_2hakl","items":"o3vFi","bucket":"_16MAF"};